import { render, staticRenderFns } from "./dashboardRequisitosUnidades.vue?vue&type=template&id=4d5b9116&"
import script from "./dashboardRequisitosUnidades.vue?vue&type=script&lang=js&"
export * from "./dashboardRequisitosUnidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports